import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { i18n } from 'i18next';

const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

// Create a function to get the axios instance with the current token
export function createAxiosInstance(getToken: () => Promise<string | null>, i18n: i18n, signal : AbortSignal): AxiosInstance {
    const instance = axios.create({
        baseURL,
        timeout: 60000,
        signal,
        headers: {
            'Content-Type': 'application/json',
        },
    });

    // Request interceptor
    instance.interceptors.request.use(
        async (config) => {
            try {
                const token = await getToken();
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                    config.headers["Accept-Language"] = i18n.language;
                }
            } catch (error) {
                console.error('Error getting token:', error);
            }
            return config;
        },
        (error: AxiosError) => {
            return Promise.reject(error);
        }
    );

    // Response interceptor
    instance.interceptors.response.use(
        (response: AxiosResponse) => {
            // clerk express sdk return signin page if not authenticated
            if (response.headers['Content-Type'] === 'text/html') {
                window.location.href = '/sign-in';
            }
            return response;
        },
        async (error: AxiosError) => {
            if (error.response?.status === 401) {
                // Handle unauthorized error
                // You might want to redirect to sign-in or handle token refresh
                window.location.href = '/sign-in';
            }
            return Promise.reject(error);
        }
    );

    return instance;
}
